var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.ready)?_c('v-container',{attrs:{"fluid":""}},[_c('v-progress-linear',{staticClass:"mt-4",attrs:{"indeterminate":"","color":"primary"}})],1):(_vm.useLegacy)?_c('QuoteMilestonesLegacy',{attrs:{"project":_vm.project,"users":_vm.users}}):_c('QuoteMilestonesGroups',{attrs:{"project":_vm.project,"users":_vm.users}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }